<template>
  <div class="row">
    <div class="col-xl-12">
      <container-headline
        class="col-xl-12"
        :headline="$t('global.presencejournal')"
        :col="3"
      >
        <div class="row mt-2 d-flex justify-content-between">
          <div class="ml-4">
            <button class="btn btn-primary mr-2" @click="openExportModal">
              <font-awesome-icon
                icon="fa-regular fa-file-export"
                class="mr-1"
              />
              <span>{{ $t("global.export") }}</span>
            </button>
            <button
              class="btn btn-primary mr-2"
              @click="toggleHasMaxHeight"
              v-if="showListToggleButton"
              v-tooltip.hover="
                            hasMaxHeight
                              ? (text = $t('global.expandlist'))
                              : (text = $t('global.collapselist'))
                          "
            >
              <font-awesome-icon
                class="mr-2"
                icon="fa-solid fa-chevron-down"
                v-if="hasMaxHeight === true"
              />
              <font-awesome-icon
                class="mr-2"
                icon="fa-solid fa-chevron-up"
                v-if="hasMaxHeight === false"
              />
              <font-awesome-icon
                icon="fa-solid fa-list"
              />
            </button>
            <button
                class="btn btn-danger ml-2"
                @click="oeffneLoeschenModal"
                v-if="editable"
                :disabled="selectedAnmeldungIds.length < 1"
              >
                <font-awesome-icon
                  icon="fa-duotone fa-trash"
                  class="mr-2"
                />
                {{ $t("global.delete") }}
              </button>
            <massenmutation-button
              v-if="editable"
              style="display: inline-flex"
              :selectedIds="selectedAnmeldungIds"
              :propEntities="propEntities"
              :modalId="'massenmutationsmodal-praesenzjournal'"
              @mutated="get()"
            />
            <b-form-checkbox
              v-model="zeigeGeplante"
              switch
              class="d-inline-block ml-3"
            >
              {{ $t("global.planned") }}
            </b-form-checkbox>
          </div>
          <div class="col-xl-3">
            <div class="form-group" v-if="person">
              <v-select
                v-model="fach"
                :getOptionLabel="(f) => f.kuerzel"
                :options="faecher"
                :placeholder="$t('global.Subject')"
                :clearable="true"
              >
                <span slot="no-options">{{ $t("global.taptosearch") }}</span>
              </v-select>
              <label>{{ $t("global.Subject") }}</label>
            </div>
            <div class="form-group" v-if="fachid">
              <v-select
                v-model="anmeldung"
                label="personName"
                :options="anmeldungen"
                :placeholder="$t('global.registrations')"
                :clearable="true"
              >
                <span slot="no-options">{{ $t("global.taptosearch") }}</span>
              </v-select>
              <label>{{ $t("global.registration") }}</label>
            </div>
          </div>
        </div>
      </container-headline>
      <div class="row col-xl-12">
        <div class="col-xl-12 block belegliste br-t-l-0">
          <div>
            <div ref="tableParent">
              <b-table
                ref="selectableTable"
                tbody-tr-class="item"
                :style="hasMaxHeight ? 'max-height: 300px' : ''"
                responsive
                sticky-header
                :items="liste"
                :fields="fields"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :busy="isBusy"
                show-empty
                sort-icon-left
                selectable
                select-mode="range"
                @row-dblclicked="details"
                thead-tr-class="pointer"
              >
                <template v-slot:head(selected)="row">
                  <b-form-checkbox
                    v-model="row.selected"
                    @input="selectAllRows(row)"
                  ></b-form-checkbox>
                </template>

                <template v-slot:cell(selected)="row">
                  <b-form-checkbox
                    v-model="row.item.selected"
                    @input="onRowSelected(row)"
                  ></b-form-checkbox>
                </template>

                <template v-slot:cell(unterrichtsinhalt)="row">
                  <span
                    v-for="(inhalt, index) in row.item.unterrichtsinhalt"
                    :key="index"
                    >{{ inhalt.bezeichnung }} <br />
                  </span>
                </template>

                <template #table-busy>
                  <div class="text-center text-primary my-2">
                    <b-spinner class="align-middle"></b-spinner>
                  </div>
                </template>

                <template #empty>
                  <div v-if="ladeFehler" class="text-center text-danger my-2">
                    <strong>{{ $t("global.errorwhileloading") }}</strong>
                  </div>
                  <div v-if="!ladeFehler" class="text-center text-primary my-2">
                    <strong>{{ $t("global.nodataavailable") }}</strong>
                  </div>
                </template>
              </b-table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <anwesenheiten-export-modal
      :id="'anwesenheiten-export-modal'"
      :person="gp"
    />
    <loeschen-modal
      id="praesenzen-loeschen-modal"
      :selectedIds="selectedAnmeldungIds"
      @confirmed="praesenzenLoeschen"
      :multiple="true"
    />
  </div>
</template>

<script>
import Api from "@/api/Api";
import AppApi from "@/api/AppApi";
import { apiErrorToAlert } from "@/utils/Errorhandler";
import { BSpinner } from "bootstrap-vue";
import ContainerHeadline from "@/components/ContainerHeadline";
import AnwesenheitenExportModal from "@/components/Modals/AnwesenheitenExportModal.vue";
import reiter from "@/mixins/Reiter";
import LoeschenModal from "@/components/Modals/LoeschenModal";
import MassenmutationButton from "@/components/Buttons/MassenmutationButton";

export default {
  name: "Praesenzjournalliste",
  components: {
    ContainerHeadline,
    BSpinner,
    AnwesenheitenExportModal,
    LoeschenModal,
    MassenmutationButton,
  },
  mixins: [reiter],
  props: {
    fachid: {
      type: String,
      required: false,
    },
    person: {
      type: String,
      required: false,
    },
    shown: {
      type: Boolean,
      required: false,
    },
    editable: {
      type: Boolean,
      required: true,
    },
    gp: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      page: 0,
      anzahlProPage: 99,
      sortBy: "",
      sortDesc: false,
      isBusy: false,
      ladeFehler: false,
      praesenzen: [],
      faecher: [],
      anmeldungen: [],
      fach: null,
      anmeldung: null,
      zeigeGeplante: false,
      selected: [],
      selectedAnmeldungIds: [],
      propEntities: [
        {
          tbl_name: "bxc_praesenz",
          selectedIds: [],
        },
      ],
      hasMaxHeight: true,
      showListToggleButton: null,
    };
  },
  watch: {
    shown(val) {
      if (val && this.praesenzen.length == 0) this.get();
    },
    // Auswahl leeren, damit keine ausgeblendeten Zeilen gelöscht/mutiert werden
    fach() {
      this.auswahlZuruecksetzen();
    },
    anmeldung() {
      this.auswahlZuruecksetzen();
    },
    zeigeGeplante() {
      this.auswahlZuruecksetzen();
    },
  },
  computed: {
    liste() {
      return this.praesenzen.filter(
        (praesenz) =>
          (this.zeigeGeplante || this.istSichtbar(praesenz)) &&
          (!this.fach || praesenz.fach?.id == this.fach.id) &&
          (!this.anmeldung || praesenz.anmeldung?.id == this.anmeldung.id)
      );
    },
    fields() {
      return [
        { key: "selected", label: "" },
        {
          key: "praesenzstatus.bezeichnung",
          sortable: false,
          label: this.$t("global.presencestatus"),
        },
        {
          key: "termin.von",
          sortable: false,
          label: this.$t("global.date"),
          formatter: (value) => {
            if (value) {
              return new Date(value).toLocaleDateString();
            } else {
              return "-";
            }
          },
        },
        {
          key: "note",
          sortable: true,
          label: this.$t("global.grade"),
          tdClass: "text-center",
          thClass: "text-center",
        },
        {
          key: "fach.bezeichnung",
          sortable: true,
          label: this.$t("global.subject"),
        },
        {
          key: "unterrichtsinhalt",
          sortable: true,
          label: this.$t("global.lessoncontent"),
        },
        {
          key: "fachkompetenzen",
          sortable: true,
          label: this.$t("global.subjectprofessionalcompetencies"),
        },
        {
          key: "sozialverhalten",
          sortable: true,
          label: this.$t("global.worksocialbehavior"),
        },
        {
          key: "termin.bemerkung_unterricht",
          sortable: true,
          label: this.$t("global.comment"),
        },
      ];
    },
  },
  mounted() {
    if (this.shown && this.praesenzen.length == 0) this.get();
  },
  created() {
    if (this.fachid)
      this.fields.push({
        key: "anmeldung.personName",
        sortable: true,
        label: this.$t("global.registration"),
      });
  },
  methods: {
    get() {
      this.isBusy = true;

      Api.get("geschaeftspartner/praesenzen/", {
        params: {
          fachId: this.fachid,
          personId: this.person,
          page: this.page,
          count: this.anzahlProPage,
        },
      })
        .then((response) => {
          this.praesenzen = response.data.praesenzen;
          this.selectedAnmeldungIds = [];
          this.faecher = response.data.faecher;
          this.anmeldungen = response.data.anmeldungen;
          this.ladeFehler = false;
        })
        .catch((e) => {
          this.$notify(apiErrorToAlert(e));
          this.ladeFehler = true;
        })
        .finally(() => {
          this.isBusy = false;
          this.$nextTick(() => {
            this.showListToggleButton = !(
              this.$refs.tableParent.clientHeight < 300
            );
          });
        });
    },

    // Offene Präsenzen in der Zukunft (geplant) sind standardmässig ausgeblendet
    istSichtbar(praesenz) {
      return (
        praesenz.praesenzstatus?.id !== "17646E707EB" ||
        this.istVergangen(praesenz)
      );
    },

    auswahlZuruecksetzen() {
      this.praesenzen.forEach((praesenz) => {
        praesenz.selected = false;
      });
      this.selectedAnmeldungIds = [];
      this.$forceUpdate();
    },

    istVergangen(praesenz) {
      if (!praesenz.termin?.bis) return false;

      const today = new Date();
      const praesenzDate = new Date(praesenz.termin.bis);

      return praesenzDate < today;
    },

    details(praesenz) {
      this.$router.push({
        name: "anwesenheit",
        params: {
          vid: praesenz.fach.id,
          tid: praesenz.termin.id,
        },
      });
    },

    selectAllRows(row) {
      if (row.selected) {
        this.$refs.selectableTable.items.forEach((gp) => {
          gp.selected = true;
        });
      } else {
        this.$refs.selectableTable.items.forEach((gp) => {
          gp.selected = false;
        });
        this.selectedAnmeldungIds = [];
      }
      this.$forceUpdate();
    },

    onRowSelected(row) {
      if (row.item.selected) {
        this.selectedAnmeldungIds.push(row.item.id);
      } else {
        this.selectedAnmeldungIds = this.selectedAnmeldungIds.filter(
          (id) => id != row.item.id
        );
      }
    },
    openExportModal() {
      if (this.gp == null) return;
      this.$bus.$emit("openAnwesenheitenExportModal");
    },
    oeffneLoeschenModal() {
      if (this.selectedAnmeldungIds.length > 0)
        this.$bus.$emit(
          "openLoeschenModal",
          "praesenzen-loeschen-modal"
        );
    },
    praesenzenLoeschen() {
      AppApi.delete("praesenzliste/", { data: this.selectedAnmeldungIds })
        .then((response) => {
          this.$notify({
            type: "success",
            title: this.$t("global.actionsuccessful"),
            text: "",
          });
          this.selectedAnmeldungIds = []
          this.get()

        })
        .catch((error) => {
          this.$notify({
            type: "error",
            title: this.$t("global.actionfailed"),
            text: "",
          });
        })
        .finally(() => {
          this.$bus.$emit("searchWithFilter");
        });
    },
    toggleHasMaxHeight() {
      this.hasMaxHeight = !this.hasMaxHeight;
    },
  },
};
</script>
